import _ from "lodash";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_VARIANT_CGC,
  CURRICULUM_VARIANT_CAMBRIDGE,
  CURRICULUM_VARIANT_TODDLE_PLAY,
  CURRICULUM_VARIANT_AUSC,
  CURRICULUM_VARIANT_OPEN,
  CURRICULUM_VARIANT_ENC,
  CURRICULUM_VARIANT_ENC_GCSE,
  CURRICULUM_VARIANT_ENC_ALEVEL,
  CURRICULUM_VARIANT_WAC_K10,
  CURRICULUM_VARIANT_WACE,
} from "Constants/stringConstants";

export const MAXIMUM_ACRONYM_LENGTH = 5;

export const getCurriculumProgramName = ({ type, variant }) => {
  const key = variant ? variant : type;
  switch (key) {
    case CURRICULUM_TYPE_PYP: {
      return "Primary Years Programme";
    }
    case CURRICULUM_TYPE_MYP: {
      return "Middle Years Programme";
    }
    case CURRICULUM_TYPE_UBD: {
      return "Understanding by Design";
    }
    case CURRICULUM_TYPE_DP: {
      return "Diploma Programme";
    }
    case CURRICULUM_VARIANT_CGC: {
      return "Common Grounds Collaborative";
    }
    case CURRICULUM_VARIANT_ENC: {
      return "English National Curriculum";
    }
    case CURRICULUM_VARIANT_ENC_GCSE: {
      return "English National curriculum - GCSE";
    }
    case CURRICULUM_VARIANT_ENC_ALEVEL: {
      return "English National curriculum - A level";
    }
    case CURRICULUM_VARIANT_CAMBRIDGE: {
      return "Cambridge IGCSE";
    }
    case CURRICULUM_VARIANT_TODDLE_PLAY: {
      return "Toddle Play";
    }
    case CURRICULUM_VARIANT_OPEN: {
      return "Independent Curriculum Programme";
    }
    case CURRICULUM_VARIANT_AUSC: {
      return "Australian Curriculum Programme";
    }
    case CURRICULUM_VARIANT_WAC_K10: {
      return "Western Australian Curriculum K-10";
    }
    case CURRICULUM_VARIANT_WACE: {
      return "Western Australian Certificate of Education";
    }
  }
};

export const getCurriculumProgramAcronym = ({ type, variant }) => {
  const key = variant ? variant : type;
  switch (key) {
    case CURRICULUM_TYPE_PYP: {
      return "PYP";
    }
    case CURRICULUM_TYPE_MYP: {
      return "MYP";
    }
    case CURRICULUM_TYPE_UBD: {
      return "UbD";
    }
    case CURRICULUM_TYPE_DP: {
      return "DP";
    }
    case CURRICULUM_VARIANT_CGC: {
      return "CGC";
    }
    case CURRICULUM_VARIANT_ENC: {
      return "ENC";
    }
    case CURRICULUM_VARIANT_ENC_GCSE: {
      return "GCSE";
    }
    case CURRICULUM_VARIANT_ENC_ALEVEL: {
      return "ENC-A";
    }
    case CURRICULUM_VARIANT_CAMBRIDGE: {
      return "CAMB";
    }
    case CURRICULUM_VARIANT_TODDLE_PLAY: {
      return "PLAY";
    }
    case CURRICULUM_VARIANT_OPEN: {
      return "INDP";
    }
    case CURRICULUM_VARIANT_AUSC: {
      return "AusC";
    }
    case CURRICULUM_VARIANT_WAC_K10: {
      return "WAC";
    }
    case CURRICULUM_VARIANT_WACE: {
      return "WACE";
    }
  }
};

export const getGlobalGradesForCurriculumProgram = ({
  curriculumProgramType,
  globalGrades,
  initiallySelectedGlobalGrades = [],
}) => {
  if (_.isEmpty(curriculumProgramType)) {
    return globalGrades;
  }

  return _.filter(globalGrades, ({ curriculumTypes, id }) => {
    return (
      _.includes(curriculumTypes, curriculumProgramType) ||
      _.includes(initiallySelectedGlobalGrades, id)
    );
  });
};

export const EXAM_SESSION_TIMEZONES = [
  {
    id: 1,
    label: "TZ1",
    regions: "Latin America and North America",
  },
  {
    id: 2,
    label: "TZ2",
    regions: "Africa, Europe, Middle East and Asia-Pacific",
  },
];
